// extracted by mini-css-extract-plugin
export default {"breadcrumbs_container":"breadcrumbs_breadcrumbs_container__LgxAD"};